import {
  createExtension,
  coreExtensionData,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import Box from '@mui/material/Box';

/**
 * Overrides Backstage's default `app/layout` (which wraps everything in a
 * SidebarPage). Wibblewabble uses a top-bar brand band instead of a left
 * sidebar, so we render the routed content full-bleed and drop the nav.
 */
export const wwAppLayout = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    nav: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
      optional: true,
    }),
    // Optional so the sign-in bootstrap phase (which stops at the session
    // boundary and doesn't instantiate the routed content) still resolves a
    // root element instead of throwing.
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
      optional: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  factory: ({ inputs }) => [
    coreExtensionData.reactElement(
      <Box sx={{ minHeight: '100vh' }}>
        {inputs.content?.get(coreExtensionData.reactElement)}
      </Box>,
    ),
  ],
});
